import React, { useState, useCallback } from 'react';
import './AllNotificationsPopup.css';
import bloodPressure from '../assets/Property 1=Blood pressure.png';
import notes from '../assets/Property 1=Notes.png'
import device from '../assets/Property 1=Patient Vitals.png';
import { formatDateWithTime } from '../utils/dateUtils';
import { useDispatch, useSelector } from 'react-redux';
import Logger from '../services/Logger';
import { LogElements, LogAction } from '../services/LogElements';

const AllNotificationsPopup = ({ 
  notifications, 
  onClose, 
  formatNotificationText, 
  formatTimeAgo, 
  markNotificationAsRead 
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterCompleted, setFilterCompleted] = useState(false);
  const dateFormat = useSelector((state) => state.userInfo.dateFormat);

  const handleOverlayClick = useCallback((e) => {
    Logger.shared.info(
      LogElements.notificationOverlay,
      LogAction.clicked,
      'AllNotificationsPopup.js'
    );
    // Only close if clicking the overlay itself, not its children
    if (e.target.className === 'all-notifications-overlay') {
      onClose();
    }
  }, [onClose]);

  const filteredNotifications = filterCompleted
    ? notifications.filter(notification => notification.readStatus)
    : notifications.filter(notification => notification.notificationContent.toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)); // Sort by date, newest first

    const getIcon = (notification) => {
      if (notification.notificationContent.includes ("threshold")) {
        return bloodPressure;
      } else if (notification.notificationContent.includes ("report")) {
        return notes;
      } else {
        return device;
      }
    }
  
    const getSource = (notification) => {
      if (notification.notificationContent.includes ("threshold")) {
        return 'Perin Patch';
      } else if (notification.notificationContent.includes ("report")) {
        return 'Mobile';
      } else if (notification.notificationContent.includes ("Reminder")) {
        return 'System';
      } else {
        return 'Perin Patch';
      }
    };

    // const clickedAcknowledge = (not) => {

    // };

    const showCompleted = () => {
      Logger.shared.info(
        LogElements.showCompletedButton,
        LogAction.clicked,
        'sample.js'
    );
      setFilterCompleted(!filterCompleted)
    };

  return (
    <div className="all-notifications-overlay" onClick={handleOverlayClick}>
      <div className="all-notifications-popup">
        <div className="all-notifications-header">
          <h2 style={{ 
            color: '#4F4F4F',
            fontSize: '20px',
            fontFamily: 'Roboto',
            fontWeight: '500',
            lineHeight: '28px',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            wordWrap: 'break-word'
          }}>All Notifications</h2>
          <button
            onClick={showCompleted}
            className={`show-completed-btn${filterCompleted ? ' active' : ''}`}
          >
            Completed
          </button>
          <button className="close-button-notifications" onClick={onClose}>✕</button>
        </div>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search Item"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>
        <div className="all-notifications-content">
          {filteredNotifications.length > 0 ? (
            filteredNotifications.map((notification, index) => (
              <div 
                key={index} 
                className={`notification-item${notification.readStatus ? "" : '-unread'}`}
                onClick={() => markNotificationAsRead(notification)}
              >
                <div className="notification-circle">
                    <img 
                        src={getIcon(notification)} 
                        alt="User Profile" 
                        style={{
                            width: '24px',
                            height: '24px'
                          }}
                    />
                  </div>
                <div className="notification-content">
                  <div dangerouslySetInnerHTML={{ 
                    __html: formatNotificationText(
                      notification.notificationContent, 
                      notification.accountName
                    ) 
                  }} />
                  <div className="notification-time">
                      <span>{`Priority: Low | Source: ${getSource(notification)}`}</span>
                      {`${formatTimeAgo(notification.createdDate)}`}
                    </div>
                   
                </div>
              </div>
            ))
          ) : (
            <div className="no-notifications">
              <div>{searchQuery ? "No matching notifications" : "No notifications available"}</div>
            </div>
          )}
        </div>
        <div className="notifications-overlay-frame" />
      </div>
    </div>
  );
};

export default AllNotificationsPopup; 